

<app-academic-student-details></app-academic-student-details>
